<template>
  <div v-if="userData">
    <!-- pricing plan modal -->
    <Modal
      :value="pricingModal"
      modalName="Choose your billing plan"
      maxWidth="1000px"
      top="auto"
      :loading="subscriptionIsUpdating"
      @input="closePricingModal"
    >
      <div class="pb-28">
        <PlanCards
          :switchPlanAction="switchPlanAction"
          :currentDeal="currentDeal"
          @subscribe-to="paddleCheckout"
          @switch-to="proRateOnDealSwitch"
        />
      </div>
    </Modal>
    <!-- paddle update quantity modal -->
    <Modal
      v-if="currentDeal"
      :value="updateSeatsModal"
      modalName="Update quantity of licenses"
      @input="toggleModal({ name: 'updateSeatsModal' })"
      >
      <div v-if="currentDealIsBulk" class="modal-pro-options">
        <p><strong>On Bulk offer, you can update the number of licenses by changing the number of bulks.</strong></p>
        <p>Right now you have <strong>{{currentDeal.quantity}} bulk</strong> that gives you <strong>{{currentDeal.licensesQuantity}} licenses</strong>.</p>
        <p>Change the number of bulks to add or remove {{currentDeal.licensesQuantity}} licenses.</p>
        <p>Every bulk of licenses added will be charged separately according to the current pricing plan.</p>
        <div class="subscribe__item-qty-text">
          new quantity:
        </div>
        <div class="subscribe__item-qty">
          <integer-plusminus
            :value="currentDeal.quantity"
            :min="1"
            @input="(val) => updatedNumberOfLicenses = val"
          />
        </div>
        <button
          :disabled="subscriptionIsUpdating || updatedNumberOfLicenses === 0 || updatedNumberOfLicenses === currentDeal.quantity"
          class="modal-pro-options__button"
          @click="updateNumberOfLicenses()"
        >SAVE</button>
      </div>
      <div v-else class="modal-pro-options">
        <p>Right now you have <strong>{{currentDeal.quantity}}</strong> licenses.</p>
        <p>Choose the new license quantity.</p>
        <p>Each license added will be charged separately according to the current pricing plan.</p>
        <div class="subscribe__item-qty-text">
          new quantity:
        </div>
        <div class="subscribe__item-qty">
          <integer-plusminus
            :value="currentDeal.quantity"
            :min="1"
            @input="(val) => updatedNumberOfLicenses = val"
          />
        </div>
        <button
          :disabled="subscriptionIsUpdating || updatedNumberOfLicenses === 0 || updatedNumberOfLicenses === currentDeal.quantity"
          class="modal-pro-options__button"
          @click="updateNumberOfLicenses()"
        >SAVE</button>
      </div>
    </Modal>
    <!-- paddle update plan modal -->
    <Modal
      v-if="currentDeal"
      :value="proRateModal"
      modalName="Update Pricing Plan"
      @input="toggleModal({ name: 'proRateModal' })"
      >
      <div class="modal-pro-options" >
        <div v-html="paddleUpdatePreviewText"></div>
        <button
          :disabled="subscriptionIsUpdating"
          class="modal-pro-options__button"
          @click="switchDeal(switchToDealId)"
        >PROCEED</button>
      </div>
    </Modal>
    <!-- paddle success modal -->
    <Modal
      v-model="paddleSuccessModal"
      modalName="Success"
      >
      <div class="modal-pro-options">
        <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-695.000000, -346.000000)" fill="#0FD37B" fill-rule="nonzero">
              <g transform="translate(472.000000, 249.000000)">
                <path d="M260.666887,100.385145 C261.27017,100.735177 261.476883,101.506464 261.129643,102.110882 C260.779961,102.71955 260.001489,102.928078 259.393945,102.575574 C248.599406,96.3124562 234.798061,100.029912 228.564727,110.87987 C222.328953,121.734077 226.028912,135.614854 236.827714,141.880445 C238.851908,143.054906 241.021681,143.901922 243.281352,144.399976 C243.963902,144.550417 244.395555,145.224439 244.246689,145.906555 C244.097319,146.590981 243.420176,147.024403 242.735296,146.873448 C240.220129,146.319081 237.805172,145.376583 235.554772,144.070874 C223.549374,137.105202 219.436035,121.681842 226.366273,109.618826 C233.298952,97.5515626 248.657226,93.4169998 260.666887,100.385145 Z M271.822723,126.03334 C272.533968,126.152663 273.008381,126.783462 272.883671,127.44502 C272.358773,130.22946 271.322266,132.903505 269.809402,135.37549 C266.286326,141.131777 260.489261,145.252855 253.651213,146.865633 C252.944534,147.032306 252.226515,146.632225 252.052101,145.9741 C251.879507,145.322841 252.305251,144.664318 253.004871,144.49931 C259.149913,143.049981 264.355362,139.347654 267.524752,134.169246 C268.888487,131.940935 269.822148,129.53255 270.295004,127.024175 C270.420679,126.357506 271.106234,125.913136 271.822723,126.03334 Z M264.599371,108.813663 C265.178776,108.185461 266.157736,108.145903 266.785938,108.725308 C267.41414,109.304714 267.453698,110.283673 266.874292,110.911875 L266.874292,110.911875 L244.651665,135.006062 L233.363925,122.164288 C232.799716,121.522402 232.862686,120.544669 233.504572,119.980461 C234.146457,119.416252 235.12419,119.479222 235.688398,120.121108 L235.688398,120.121108 L244.565179,130.219995 L244.852642,130.223435 Z M272.663237,119.485318 C272.829957,120.408591 272.941819,121.338484 272.998338,122.270986 C273.034077,122.860631 272.488979,123.367112 271.783239,123.40065 C271.07179,123.434459 270.459042,122.974356 270.422948,122.378857 C270.370699,121.516815 270.26729,120.657173 270.113174,119.803701 C270.008691,119.22509 270.482617,118.680039 271.174527,118.58208 C271.882908,118.481788 272.555724,118.889928 272.663237,119.485318 Z"></path>
              </g>
            </g>
          </g>
        </svg>
        <p>Your subscription was successfully updated</p>
        <button class="modal-pro-options__button" @click="paddleSuccessModal = false">OK</button>
      </div>
    </Modal>
    <!-- paddle error modal -->
    <Modal
      v-model="paddleErrorModal"
      modalName="Error"
      >
      <div class="modal-pro-options">
        <p>There was an error, please try again later</p>
        <p>{{paddleUpdateError}}</p>
        <button class="modal-pro-options__button" @click="paddleErrorModal = false">OK</button>
      </div>
    </Modal>
    <!-- paddle cancellation result modal -->
    <Modal
      v-if="currentDeal"
      v-model="paddleCancellationResultModal"
      modalName="Your subscription is canceled"
      >
      <div class="unsubscribe-modal">
      <div class="unsubscribe-modal__content-wrap text--align-center">
        <p>Your paid plan will expire on {{ dealExpirationDate }} and your websites will be downgraded to Free. After that, all the paid features will become unavailable on your website.</p>
        <p>You are welcome back anytime!</p>
      </div>

        <div class="unsubscribe-modal__btns justify-center">
          <UiBtn
            wide
            type="secondary"
            @click="paddleCancellationResultModal = false"
          >
            Ok
          </UiBtn>
        </div>
      </div>
    </Modal>
    <!-- request more licenses from workspace owner modal -->
    <Modal
      :value="seatsRequestModal"
      modalName="You’ve reached the license limit"
      @input="toggleModal({ name: 'seatsRequestModal' })"
      >
      <div class="modal-pro-options">
        <p>If you need more licenses, please ask the workspace owner to update their subscription plan, or downgrade one of the existing websites to Free.</p>
        <button class="modal-pro-options__button" @click="toggleModal({ name: 'seatsRequestModal' })">OK</button>
      </div>
    </Modal>
    <!-- unsubscribe quiz -->
      <UnsubscribeQuiz
        v-if="currentDeal"
        :value="unSubscriptionQuizModal"
        :currentDeal="currentDeal"
        @unsubscribe="cancelSubscription"
        @close="toggleModal({ name: 'unSubscriptionQuizModal' })"
      />
    <!-- go to billing to get more licenses modal -->
    <Modal
      :value="addMoreSeatsInfoModal"
      :modalName="'You’ve reached your licenses limit'"
      closeOnPressEscBtn
      class="confirmation-popup"
      alignTitleLeft
      @input="toggleModal({ name: 'addMoreSeatsInfoModal' })"
    >
      <div class="confirmation-popup__content">
        <p>There are no available licenses on your plan.</p>
        <p>To apply this type of license to a website, do one of the following steps:</p>
        <ul>
          <li>downgrade one of the existing websites to Free in your workspace</li>
          <li>add more licenses in your <router-link :to="{name: 'account-billing'}">Billing Settings</router-link>.</li>
        </ul>
      </div>
      <div class="confirmation-popup__btns">
        <UiBtn
          type="secondary"
          @click="toggleModal({ name: 'addMoreSeatsInfoModal' })">OK</UiBtn>
        <UiBtn
          type="primary"
          @click="goToBilling">ADD MORE LICENSES</UiBtn>
      </div>
    </Modal>
    <!-- update website plan from ProOptionWrapper -->
    <Modal
      :value="offerToChangeWebsitePlan"
      :modalName="'This feature is not available on your current subscription plan'"
      closeOnPressEscBtn
      class="confirmation-popup"
      alignTitleLeft
      @input="toggleModal({ name: 'offerToChangeWebsitePlan' })"
    >
      <div class="confirmation-popup__content">
        <p>You cannot enable this feature with the current license applied to this website.</p>
        <p>Please apply a different license to the website to use this feature.</p>
      </div>
      <div class="confirmation-popup__btns">
        <UiBtn
          type="secondary"
          @click="toggleModal({ name: 'offerToChangeWebsitePlan' })">OK</UiBtn>
      </div>
    </Modal>
    <Preloader :loading="subscriptionIsUpdating"/>
  </div>
</template>
<script>
import moment from 'moment'
import { IntegerPlusminus } from 'vue-integer-plusminus'
import api from '@/services/api/'
import { mapState, mapActions, mapGetters } from 'vuex'
import { get } from '@/modules/utils/'
import Modal from '@/components/modal'
import UnsubscribeQuiz from './unsubscription/UnsubscribeQuiz'
import UiBtn from '@/components/ui-btn'
import PlanCards from '@/components/plan-cards'
import planManager from '@devstark/spreadsimple-plan-manager'
const dealsConfig = planManager.deals

export default {
  name: 'SubscriptionComponent',
  components: {
    Modal,
    UnsubscribeQuiz,
    IntegerPlusminus,
    UiBtn,
    PlanCards
  },
  data () {
    return {
      paddleSuccessModal: false,
      paddleErrorModal: false,
      paddleCancellationResultModal: false,
      paddleUpdateError: '',
      currentDeal: undefined,
      subscriptionIsUpdating: false,
      paddleUpdatePreviewText: '',
      updatedNumberOfLicenses: 0,
      dealsConfig: dealsConfig,
      switchPlanAction: false,
      switchToDealId: undefined
    }
  },
  computed: {
    ...mapState('app', [
      'userData',
      'seatsRequestModal',
      'updateSeatsModal',
      'addMoreSeatsInfoModal',
      'offerToChangeWebsitePlan',
      'pricingModal',
      'unSubscriptionQuizModal',
      'paymentDetailsModal',
      'proRateModal',
      'currentSpreadViewId'
    ]),
    ...mapGetters('app', [
      'canSubscribeToPaidPlan'
    ]),
    paddleEnv () {
      return process.env.VUE_APP_PADDLE_ENV === 'sandbox' ? 'staging' : 'production'
    },
    email () {
      return get(this.userData, 'email', '')
    },
    dealExpirationDate () {
      if (!this.currentDeal) return ''
      const date = moment(new Date(this.currentDeal.nextBillDate.toString()))
      return moment(date).format('MMMM D YYYY')
    },
    equalAnnualDeal () {
      if (!this.currentDeal) return undefined
      const annualDealName = dealsConfig.find(d => d.name === this.currentDeal.name).identicAnnual
      return dealsConfig.find(d => d.name === annualDealName)
    },
    annualDealId () {
      if (!this.equalAnnualDeal) return undefined
      return this.equalAnnualDeal.paddleId[this.paddleEnv]
    },
    currentDealIsAnnual () {
      if (!this.currentDeal) return false
      return this.currentDeal.period === 'year'
    },
    annualDealDiscount () {
      if (!this.userData.temporaryDiscounts) return undefined
      const annualDiscount = this.userData.temporaryDiscounts.find(d => d.name === 'switch to annual plan')
      if (annualDiscount && !annualDiscount.applied) {
        return annualDiscount
      }
      return undefined
    },
    currentDealIsBulk () {
      if (!this.currentDeal) return undefined
      return this.currentDeal.type.includes('bulk')
    },
    addDiscountOnProRate () {
      if (!this.annualDealDiscount) return {}
      if (!this.equalAnnualDeal) return {}
      const offer = this.annualDealDiscount
      return {
        keep_modifiers: false,
        currency: 'USD',
        recurring_price: (this.equalAnnualDeal.price.year * (100 - offer.size) / 100).toFixed(2)
      }
    },
    addDiscountOnUpdate () {
      if (!this.annualDealDiscount) return {}
      const offer = this.annualDealDiscount
      return {
        keep_modifiers: false,
        discountName: offer.name
      }
    }
  },
  watch: {
    'unSubscriptionQuizModal' (val) {
      if (val) {
        this.$trackEvent({
          'event': 'subscriptionCancelAttempt'
        })
      }
    },
    'paymentDetailsModal' (val) {
      if (val) {
        this.updateBillingInfo()
        this.toggleModal({ name: 'paymentDetailsModal', value: false })
      }
    },
    'proRateModal' (val) {
      if (!val) {
        this.switchToDealId = undefined
      }
    }
  },
  methods: {
    ...mapActions('app', [
      'fetchUserData',
      'fetchWorkspaces',
      'toggleModal',
      'updateSpreadViewDeal'
    ]),
    async refetchSubscriptions (attempt = 1, max = 5) {
      let nextAttempt = attempt
      const currentSubsHash = this.userData.dealOptions.dealBasket.reduce((acc, d) => { return acc.concat(d.name) }, '')
      if (nextAttempt > max) return
      const res = await this.fetchUserData()
      const newSubsHash = res.dealOptions.dealBasket.reduce((acc, d) => { return acc.concat(d.name) }, '')
      if (currentSubsHash !== newSubsHash) {
        await this.fetchWorkspaces()
        return
      }
      nextAttempt++
      let timeout = new Promise(async (resolve) => {
        setTimeout(() => { resolve() }, 1500)
      })
      await timeout
      await this.refetchSubscriptions(nextAttempt)
    },
    goToBilling () {
      this.toggleModal({ name: 'addMoreSeatsInfoModal' })
      this.$router.push({ name: 'account-billing' })
    },
    async proRatePreview (newDealId, newDealLabel, switchToAnnual) {
      const newDeal = this.dealsConfig.find(d => d.paddleId[this.paddleEnv] === newDealId)
      let newQuantity = this.currentDeal.quantity
      if (newDeal?.type.includes('bulk')) {
        newQuantity = 1
      }
      this.paddleUpdatePreviewText = '<p>Loading pro-rated prices preview...</p>'
      const result = await api.paddlePreviewUpdateProxy(Object.assign({
        subscription_id: this.currentDeal.subscriptionId,
        plan_id: newDealId,
        quantity: newQuantity,
        bill_immediately: true,
        prorate: true,
        keep_modifiers: true
      }, switchToAnnual ? this.addDiscountOnProRate : null))
      if (!result.success) {
        this.toggleModal({ name: 'proRateModal' })
        this.paddleUpdateError = result.error.message
        this.paddleErrorModal = true
      } else {
        this.paddleUpdatePreviewText =
        `<p>Your current plan: <strong>${this.currentDeal.label} x ${this.currentDeal.quantity}</strong>.</p>
        <p>Your new plan: <strong>${newDealLabel} x ${newQuantity}</strong>.</p>
        <p><strong>${result.response.immediate_payment.amount < 0
    ? `You won't be charged now. The next payment will be $${result.response.next_payment.amount}.</strong></p>`
    : `You will be billed $${result.response.immediate_payment.amount} now. The next payment will be $${result.response.next_payment.amount}.</strong></p>`
}`
        this.switchToDealId = newDealId
      }
    },
    proRateOnDealSwitch (payload) {
      this.toggleModal({ name: 'pricingModal' })
      this.toggleModal({ name: 'proRateModal', value: true })
      this.proRatePreview(payload.id, payload.label, false)
    },
    async switchDeal (newDealId) {
      this.paddleUpdateError = ''
      this.subscriptionIsUpdating = true
      const switchToAnnual = newDealId === this.annualDealId
      const newDeal = this.dealsConfig.find(d => d.paddleId[this.paddleEnv] === newDealId)
      let newQuantity = this.currentDeal.quantity
      if (newDeal?.type.includes('bulk')) {
        newQuantity = 1
      }
      const result = await api.paddleUpdateSubscriptionProxy(Object.assign({
        bill_immediately: true,
        subscription_id: this.currentDeal.subscriptionId,
        plan_id: newDealId,
        quantity: newQuantity,
        keep_modifiers: true
      }, switchToAnnual ? this.addDiscountOnUpdate : null))
      if (result.success) {
        if (switchToAnnual && this.annualDealDiscount) {
          try {
            await api.applyDiscount({ name: this.annualDealDiscount.name })
            this.$trackEvent({
              'event': 'switchToAnnualWithDiscount'
            })
          } catch (e) {}
        }
        this.$trackEvent({
          'event': 'changePlan',
          'newPlan': dealsConfig.find(d => d.paddleId[this.paddleEnv] === newDealId).name
        })
        await this.refetchSubscriptions()
        await this.updateWebsiteDeal(newDeal.type, true)
        this.paddleSuccessModal = true
      } else {
        this.paddleUpdateError = result.error.message
        this.paddleErrorModal = true
      }
      this.subscriptionIsUpdating = false
    },
    async updateNumberOfLicenses () {
      if (this.updatedNumberOfLicenses === 0) {
        this.updatedNumberOfLicenses = this.currentDeal.quantity
      }
      this.paddleUpdateError = ''
      this.subscriptionIsUpdating = true
      const result = await api.paddleUpdateSubscriptionProxy({
        bill_immediately: true,
        subscription_id: this.currentDeal.subscriptionId,
        quantity: this.updatedNumberOfLicenses
      })
      if (result.success) {
        this.$trackEvent({
          'event': 'updateNumberOfLicenses',
          'increase': this.updatedNumberOfLicenses > this.currentDeal.quantity
        })
        await this.onPaddleActionSuccess()
      } else {
        this.paddleUpdateError = result.error.message
        this.paddleErrorModal = true
      }
      this.subscriptionIsUpdating = false
    },
    async paddleCheckout (payload) {
      const hadTrial = this.userData.dealOptions.hadPaddleTrial
      this.paddleUpdateError = ''
      this.subscriptionIsUpdating = true
      this.$trackEvent({
        'event': 'subscriptionClicked'
      })
      if (this.canSubscribeToPaidPlan) {
        if (hadTrial) {
          try {
            const result = await api.paddleGeneratePayLinkProxy({
              email: this.userData.email,
              dealName: payload.name
            })
            window.Paddle.Checkout.open({
              override: result.response.url,
              successCallback: async (_) => {
                this.$trackEvent({
                  'event': 'successfulSubscription',
                  'subscribedWithTrial': false
                })
                await this.refetchSubscriptions()
                await this.updateWebsiteDeal(payload.type)
                this.toggleModal({ name: 'pricingModal' })
                this.paddleSuccessModal = true
                this.subscriptionIsUpdating = false
              },
              closeCallback: (_) => {
                this.subscriptionIsUpdating = false
              }
            })
          } catch (e) {
            this.paddleErrorModal = true
            this.subscriptionIsUpdating = false
          }
        } else {
          window.Paddle.Checkout.open({
            product: payload.id,
            email: this.userData.email,
            disableLogout: true,
            successCallback: async (_) => {
              this.$trackEvent({
                'event': 'successfulSubscription',
                'subscribedWithTrial': true
              })
              await this.refetchSubscriptions()
              await this.updateWebsiteDeal(payload.type)
              this.toggleModal({ name: 'pricingModal' })
              this.paddleSuccessModal = true
              this.subscriptionIsUpdating = false
            },
            closeCallback: (_) => {
              this.subscriptionIsUpdating = false
            }
          })
        }
      } else {
        this.paddleUpdateError = 'You already have a subscription. Please proceed to billing settings to update it'
        this.paddleErrorModal = true
        this.subscriptionIsUpdating = false
      }
    },
    cancelSubscription () {
      window.Paddle.Checkout.open({
        override: this.currentDeal.cancelBillingUrl,
        successCallback: async () => {
          this.$trackEvent({
            'event': 'cancelSubscription',
            'unsubscribedFromTrial': this.currentDeal.isTrial
          })
          await this.fetchUserData()
          await this.fetchWorkspaces()
          this.paddleCancellationResultModal = true
        }
      })
    },
    updateBillingInfo () {
      window.Paddle.Checkout.open({
        override: this.currentDeal.updateBillingUrl,
        successCallback: async () => {
          this.$trackEvent({
            'event': 'updateBillingInfo'
          })
          await this.onPaddleActionSuccess()
        }
      })
    },
    async onPaddleActionSuccess () {
      await this.fetchUserData()
      await this.fetchWorkspaces()
      this.paddleSuccessModal = true
    },
    closePricingModal () {
      this.switchPlanAction = false
      this.toggleModal({ name: 'pricingModal' })
    },
    openSubscriptionModal (payload) {
      this.currentDeal = payload.dealData
      if (payload.details?.switchPlan) {
        this.switchPlanAction = true
      }
      if (payload.details?.switchPeriod) {
        this.proRatePreview(this.annualDealId, this.equalAnnualDeal?.label, true)
      }
      this.toggleModal({ name: payload.modalName, value: true })
    },
    async updateWebsiteDeal (type, onSwitch = false) {
      if (onSwitch) {
        location.reload()
        return
      }
      if (this.currentSpreadViewId) {
        const updated = await this.updateSpreadViewDeal({
          id: this.currentSpreadViewId,
          dealType: type
        })
        if (updated) {
          location.reload()
        }
      }
    }
  },
  created () {
    this.$root.$on('openSubscriptionModal', this.openSubscriptionModal)
  }
}
</script>
